import { render, staticRenderFns } from "./AddCodes.vue?vue&type=template&id=0026d406&scoped=true&"
import script from "./AddCodes.vue?vue&type=script&lang=js&"
export * from "./AddCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0026d406",
  null
  
)

export default component.exports